import React from 'react';

const VARIANT_CLASS = {
  primary: 'ads-button--primary',
  secondary: 'ads-button--secondary',
  outline: 'ads-button--outline',
  ghost: 'ads-button--ghost',
  danger: 'ads-button--danger',
  success: 'ads-button--success',
  warning: 'ads-button--warning',
};

const SIZE_CLASS = {
  sm: 'ads-button--sm',
  md: '',
  lg: 'ads-button--lg',
};

/**
 * ADS Button — canonical button primitive (Phase 1).
 */
const AdsButton = ({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  className = '',
  disabled = false,
  onClick,
  ...props
}) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  const sizeClass = SIZE_CLASS[size] || '';
  const classes = ['ads-button', variantClass, sizeClass, className].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} disabled={disabled} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default AdsButton;
